var React = require('react');

function RegPlate (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"id":"Rectangle_1651","data-name":"Rectangle 1651","width":"16","height":"16","fill":"none","key":0}),React.createElement("path",{"id":"Union_9","data-name":"Union 9","d":"M2,8A2,2,0,0,1,0,6V2A2,2,0,0,1,2,0H12a2,2,0,0,1,2,2V6a2,2,0,0,1-2,2ZM2,3V5A1,1,0,0,0,3,6h8a1,1,0,0,0,1-1V3a1,1,0,0,0-1-1H3A1,1,0,0,0,2,3ZM9,4a1,1,0,1,1,1,1A1,1,0,0,1,9,4ZM6,4A1,1,0,1,1,7,5,1,1,0,0,1,6,4ZM3,4A1,1,0,1,1,4,5,1,1,0,0,1,3,4Z","transform":"translate(1 4)","key":1})]);
}

RegPlate.defaultProps = {"id":"Reg_plate","data-name":"Reg plate","width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = RegPlate;

RegPlate.default = RegPlate;
